import React from 'react';
import { Box } from '@mantine/core';
import "./background.css"; // Import the CSS file

function HeroBackground(props) {

  const {
    children,
    fixed,
  } = props;

  return (
    <Box pos='relative' className='hero'>
      {children}
      <Box className='background stretch'>
        <Box className='fade'>
          <Box bg='violet.2' pos={fixed ? 'fixed' : 'relative'} className='pattern' />
        </Box>
      </Box>
    </Box>
  );
}

export default HeroBackground;